import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient()

export function clearSessionQueryCache() {
  try {
    queryClient.clear()
  } catch {
    /* ignore */
  }
}